import { z } from 'zod'

import { FORM_MESSAGES_MAP } from '@/constants/formMessages.constants'

import {
  estimationMethod as EstimationMethodType,
  type as ManualAccountType,
} from '@/__generated__/requests'

export const manualAccountFormSchema = z.object({
  balance: z
    .number({
      invalid_type_error: FORM_MESSAGES_MAP.EMPTY,
      required_error: FORM_MESSAGES_MAP.REQUIRED,
    })
    .min(0),
  balanceDate: z.string().optional(),
  estimationMethod: z
    .nativeEnum(EstimationMethodType, {
      message: FORM_MESSAGES_MAP.WRONG_TYPE,
    })
    .optional(),
  includedInNetWorth: z.boolean(),
  initialValue: z.number().min(0).nullable().optional(),
  initialValueDate: z.string().optional(),
  institution: z.string().optional(),
  name: z
    .string({ required_error: FORM_MESSAGES_MAP.REQUIRED })
    .min(1, { message: FORM_MESSAGES_MAP.EMPTY }),
  notes: z.string().optional().or(z.literal('')),
  otherEstimationMethod: z.string().optional(),
  otherType: z.string().optional(),
  type: z.nativeEnum(ManualAccountType, {
    message: FORM_MESSAGES_MAP.WRONG_TYPE,
  }),
  valueChanged: z.boolean(),
  valueChanges: z
    .array(
      z.object({
        date: z.string(),
        id: z.string(),
        value: z.number(),
      }),
    )
    .optional(),
})
